import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";
import "./App.scss";
import Cover from "./layouts/Cover/Cover.jsx";
import Landings from "./pages/Landings.jsx";
import TrackWeb from "./pages/TrackWeb.jsx";
import Login from "./layouts/Login/Login.jsx";
import LoginUser from "./pages/LoginUser.jsx";
import UserEdit from "./pages/UserEdit.jsx";
import PasswordRecovery from "./pages/PasswordRecovery.jsx";
import { LoginProvider } from "./context/LoginProvider.jsx";
import { BrandsProvider } from "./context/BrandsProvider.jsx";
import Metrics from "./pages/Metrics.jsx";
import Collaborators from "./pages/Collaborators.jsx";

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<Cover />}>
          <Route index element={<TrackWeb />} />
          <Route path="/landings" element={<Landings />} />
          <Route path="/metrics" element={<Metrics />} />
          <Route path="/edit-profile" element={<UserEdit />} />
          <Route path="/collaborators" element={<Collaborators />} />
        </Route>
        <Route path="/login" element={<Login />}>
          <Route path="/login" element={<LoginUser />} />
          <Route
            path="/login/password-recovery"
            element={<PasswordRecovery />}
          />
        </Route>
      </>
    )
  );

  return (
    <LoginProvider>
      <BrandsProvider>
        <RouterProvider router={router} />
      </BrandsProvider>
    </LoginProvider>
  );
}

export default App;
